<template>
  <v-card outlined>
    <v-card-text class="pa-2 pa-sm-4">
      <v-row dense align="center">
        <v-col cols="12" sm="auto">
          <create-category-dialog :group="group" @update="loadCategories" />
          <transfer-contingent-dialog
            v-if="group === 'entrant'"
            @update="loadCategories"
          />
        </v-col>
        <v-spacer />
        <v-col cols="12" sm="auto" class="d-flex align-center">
          <v-text-field
            v-model="search"
            :style="searchStyle"
            hide-details
            single-line
            prepend-icon="mdi-magnify"
            placeholder="Поиск..."
          />
          <v-btn icon @click="loadCategories">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider />

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="categories"
        :search="search"
        :options.sync="categoryOptions"
        :footer-props="{ itemsPerPageOptions: [5, 10, 20] }"
        @click:row="editCategory"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import CreateCategoryDialog from "./CreateCategoryDialog";
import TransferContingentDialog from "./TransferContingentDialog.vue";
import { getCategoryList } from "../../services/category.service";

export default {
  name: "ListTable",
  components: { CreateCategoryDialog, TransferContingentDialog },
  props: {
    group: { type: String, required: true }
  },

  data: () => ({
    search: "",

    edit: false,

    categories: [],
    headers: [{ text: "Название", value: "name" }],

    accessRules: [],
    selectedCategory: {},
    categoryOptions: {}
  }),

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    searchStyle() {
      return this.isMobile ? "max-width: 100%" : "max-width: 320px";
    }
  },

  watch: {
    categoryOptions: {
      handler() {
        this.loadCategories();
      },
      immediate: true
    }
  },

  methods: {
    async loadCategories() {
      try {
        this.categories = await getCategoryList(this.group);
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    async editCategory(item) {
      const type = item.type.toLowerCase();

      const names = {
        staff: "INFO_STAFF_EDIT_ROUTE",
        pps: "INFO_PPS_EDIT_ROUTE"
      };

      const name = names[type] || "INFO_USERS_EDIT_ROUTE";

      await this.$router.push({
        name,
        params: { group: item.type.toLowerCase(), category: item }
      });
    }
  }
};
</script>
